import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageShell } from "@/components/v2/PageShell";
import { AssetDetailPage } from "@/pages/AssetDetailPage";
import { LeaderboardsPage } from "@/pages/LeaderboardsPage";
import { MarketDetailPage } from "@/pages/MarketDetailPage";
import { MarketsPage } from "@/pages/MarketsPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { OverviewPage } from "@/pages/OverviewPage";
import { ProviderDetailPage } from "@/pages/ProviderDetailPage";
import { ProvidersPage } from "@/pages/ProvidersPage";
import "./index.css";

function ShellLayout() {
  return (
    <PageShell>
      <Outlet />
    </PageShell>
  );
}

export function App() {
  return (
    <Routes>
      <Route element={<ShellLayout />}>
        <Route path="/" element={<OverviewPage />} />
        <Route path="/leaderboards" element={<LeaderboardsPage />} />
        <Route path="/markets" element={<MarketsPage />} />
        <Route path="/markets/:provider/:marketId" element={<MarketDetailPage />} />
        <Route path="/providers" element={<ProvidersPage />} />
        <Route path="/providers/:provider" element={<ProviderDetailPage />} />
        <Route path="/assets/:asset" element={<AssetDetailPage />} />
        <Route path="/overview" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}

export default App;
